import React, { useEffect, useState } from 'react'

function UsersConnected({ users }) {
  const [lockedUsersCount, setLockedUsersCount] = useState(0);

  useEffect(() => {
    if (users && Array.isArray(users)) {
      // Filtrer les utilisateurs ayant la clé 'locked' à true
      setLockedUsersCount(users.filter(user => user.locked === true).length);
    }
  }, [users]); // Réexécuter lorsque 'users' change

  return (
    <div className="col-md-6 col-xl-3 mb-4">
        <div className="card shadow border-start-success py-2">
            <div className="card-body">
                <div className="row align-items-center no-gutters">
                    <div className="col me-2">
                        <div className="text-uppercase text-danger fw-bold text-xs mb-1"><span>Utilisateurs bloqués</span></div>
                        <div className="text-dark fw-bold h5 mb-0"><span>{lockedUsersCount}</span></div>
                    </div>
                    <div className="col-auto"><i className="fas fa-user-friends fa-2x text-gray-300"></i></div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default UsersConnected